import { render } from "./StudentInfo.vue?vue&type=template&id=8fd9bb3c&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=js"
export * from "./StudentInfo.vue?vue&type=script&lang=js"

import "./StudentInfo.vue?vue&type=style&index=0&id=8fd9bb3c&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd9bb3c"]])

export default __exports__